/* eslint-disable @next/next/no-img-element */
import Hero from "@app/components/platform/hero"
import Technology from "@app/components/platform/technology"
import Procurement from "@app/components/platform/procurement"
import Support from "@app/components/platform/support"
import Setup from "@app/components/platform/setup"
import Table from "@app/components/platform/table"

const PlatformPage = () => {
  return (
    <div>
      <Hero />
      <Technology />
      <Procurement />
      <Support />
      <Setup />
      <Table />
    </div>
  )
}

export default PlatformPage;
